export default "__VITE_ASSET__CPgfN_OC__"